// One authoritative five-minute window for both searching and an accepted
// driver offer that is not yet a confirmed ride.
export const rapidSearchWindowState = ({ status, expiresAt, now = Date.now() }) => {
  if (status === "confirmed") return "confirmed";
  if (status === "no_driver") return "no_driver";
  if (status === "cancelled") return "cancelled";
  if (!["searching","driver_reserved"].includes(status)) return "other";
  const deadline = Date.parse(String(expiresAt || ""));
  if (Number.isFinite(deadline) && deadline <= now) return "search_finalizing";
  return status === "driver_reserved" ? "confirming" : "searching";
};
